// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { runningArrow16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-running-arrow': IconRunningArrow;
    }
}

/**
 * The icon component for the 'runningArrow' icon
 */
export class IconRunningArrow extends IconSvg {
    public constructor() {
        super(runningArrow16X16);
    }
}

registerIconSvg('icon-running-arrow', IconRunningArrow);
export const iconRunningArrowTag = 'nimble-icon-running-arrow';
